import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const ApprovalCompleteIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.866699 10C0.866699 4.95583 4.95583 0.866699 10 0.866699C15.0442 0.866699 19.1334 4.95583 19.1334 10C19.1334 15.0442 15.0442 19.1334 10 19.1334C4.95583 19.1334 0.866699 15.0442 0.866699 10ZM14.6728 7.59791C15.003 7.22641 14.9695 6.65754 14.598 6.32732C14.2265 5.99709 13.6577 6.03055 13.3274 6.40206L8.66621 11.6459L6.67228 9.40649C6.34175 9.03526 5.77285 9.00227 5.40162 9.3328C5.03039 9.66334 4.9974 10.2322 5.32793 10.6035L7.9946 13.5985C8.16546 13.7904 8.4102 13.9001 8.66715 13.9C8.92409 13.8999 9.16874 13.79 9.33944 13.5979L14.6728 7.59791Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ApprovalCompleteIcon;
